import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as Sentry from '@sentry/angular';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: false
})
@Sentry.TraceClass({ name: 'AuthComponent' })
export class AuthComponent {
  public mode = this.activatedActivated.snapshot.queryParams['mode'];

  constructor(private activatedActivated: ActivatedRoute) {}
}
